// extracted by mini-css-extract-plugin
export default {"alert_question":"style_alert_question__-NPQU","alert":"style_alert__TDjhv","alert_buttons":"style_alert_buttons__A0QDX"};